export var SUCCESS_SUFFIX = '_SUCCESS';
export var ERROR_SUFFIX = '_ERROR';
export var ABORT_SUFFIX = '_ABORT';
export var CLEAR_REQUESTS_CACHE = 'CLEAR_REQUESTS_CACHE';
export var RESET_REQUESTS = 'RESET_REQUESTS';
export var ABORT_REQUESTS = 'ABORT_REQUESTS';
export var SET_DOWNLOAD_PROGRESS = 'SET_DOWNLOAD_PROGRESS';
export var SET_UPLOAD_PROGRESS = 'SET_UPLOAD_PROGRESS';
export var ADD_WATCHER = 'ADD_WATCHER';
export var REMOVE_WATCHER = 'REMOVE_WATCHER';
export var JOIN_REQUEST = 'JOIN_REQUEST';
export var STOP_POLLING = 'STOP_POLLING';
export var WEBSOCKET_OPENED = 'WEBSOCKET_OPENED';
export var WEBSOCKET_CLOSED = 'WEBSOCKET_CLOSED';
export var GET_WEBSOCKET = 'GET_WEBSOCKET';
export var OPEN_WEBSOCKET = 'OPEN_WEBSOCKET';
export var CLOSE_WEBSOCKET = 'CLOSE_WEBSOCKET';
export var STOP_SUBSCRIPTIONS = 'STOP_SUBSCRIPTIONS';